import * as yup from 'yup';
import { eTagType } from '../../types/tags/eTagType';
import { ITagData } from '../../types/tags/ITagData';

export const generateCreateTagScheme = (allTags: ITagData[]) => {
  const tagLabels: Set<string> = new Set(allTags.map((tag) => tag.label));
  return yup.object({
    label: yup
      .string()
      .test({
        name: 'Label uniqueness',
        message: 'The name of this new tag must be unique.',
        test: (value = '') => !tagLabels.has(value),
      })
      .required(),
    type: yup.mixed<eTagType>().required(),
  });
};
